export default {
    breadcrumbs: {
        practice: 'Practice',
        practice_members: 'Practice Members',
    },

    titles: {
        practice_members: '{practiceName} Members',
    },

    member_removed: 'Member permanently removed!',
    invitation_resent: 'Invitation resent!',
}
